import { exceededLimitParameter } from '../consts/errorConst';

const parameters: { [key: string]: string } = {
    'Sale.AlreadyPaid': 'Essa venda já foi paga',
    'Sale.NotFound': 'Venda não encontrada',
    'Sale.PaymentTimeExpired':
        'O tempo limite para realizar este pagamento expirou, refaça sua compra!',
    'User.LoginOrPasswordIncorrect': 'Documento ou senha incorretos',
    'User.NotFound': 'Usuário não encontrado',
    'User.AlreadyExists': 'Documento ou E-mail já utilizado por outro usuário',
    'Internal.SessionExpired': 'Sua sessão expirou',
    'AccessProfile.DoesNotAllowToBuyTickets':
        'Você não pode comprar tickets com esse perfil',
    'Horário inválido': 'Horário inválido ou necessita de maior antecedência',
    'Limite de vendas do produto':
        'Limite de vendas do produto foi ultrapassado',

    'Sale.SameGiftsUsedMultipleTimes':
        'Mesmo brinde utilizado mais de uma vez na mesma compra',
    'Gift.NotFound': 'Brinde não encontrado ou inativo',
    'Gift.IsExpired': 'Brinde com validade expirada',
    'Gift.AlreadyUsed': 'Brinde já utilizado',
    'Sale.PersonalDailyGiftLimitReached':
        'Limite de vendas com brindes do dia do usuário atingido',
    'DiscountCoupon.UnauthorizedUse': 'Cupom não pode ser usado neste contexto',
    'Sale.DailyGiftLimitReached':
        'Limite de vendas com brindes do dia atingido',
    'SalePayment.RequiredAddress': 'Adicione o local de faturamento',
    'Sale.BayWavesDailyGiftLimitReached':
        'Limite de vendas com brindes do dia atingido (ondas BAY)',
    'Sale.MonthGiftLimitReached':
        'Limite de vendas com brindes do mês atingido',
    'Sale.SessionGiftLimitReached':
        'Limite de vendas com brindes da sessão atingido',
    'Reservation.DailyFreeReefLimitReached':
        'Limite diário de onda gratuita REEF atingido para esta reserva.',
    'Reservation.DailyFreeBayLimitReached':
        'Limite diário de onda gratuita BAY atingido para esta reserva.',
    'Reservation.DailyPaidReefLimitReached':
        'Limite diário de compra adicional REEF atingido para esta reserva.',
    'Reservation.PaidBayNotAllowed':
        'Esta reserva não permite compra adicional BAY. Escolha uma sessão BAY gratuita.',
    'User.Blocked':
        'Seu usuário está bloqueado.\nEntre em contato com a central de atendimento ao Cliente',
    'User.Maintenance': 'Manutenção programada',
    'Gift.DateOfUseAfterExpirationDate':
        'Data inválida: o First Heat selecionado está fora do período de validade.\nEscolha uma sessão dentro da validade ou selecione outro First Heat disponível',
};

export const getErrorMessage = (parameter: string) => {
    // Para limite de vendas atingido
    if (parameter.includes(exceededLimitParameter)) {
        return parameters[exceededLimitParameter];
    }

    if(parameter === 'Gift.InvalidWaveLevel') {
        return 'Nivel da First Heat inválido para a sessão';
    }

    return (
        parameters[parameter] || `Ocorreu um erro desconhecido: ${parameter}`
    );
};

export const getErrorMessageExact = (parameter: string): string | undefined =>
    parameters[parameter];

export const gatewayErrorMessages: { [key: string]: string } = {
    '0': 'Transação OK',
    '10': 'Número do cartão inválido',
    '11': 'Numero do cartão inválido',
    '45': 'Método inválido',
    '81': 'Operação não permitida',
    '82': 'Transação não encontrada',
    '88': 'Cartão inválido. Verifique o número do cartão ou a forma de pagamento escolhida.',
    '89': 'Erro ao recuperar a transação',
    '100': 'Falha ao efetuar transação de pagamento',
    '101': 'Falha ao confirmar transação de pagamento',
    '102': 'Transação já finalizada ou em andamento',
    '103': 'Tipo de transação inválido',
    '109': 'Parcelas excedem o limite configurado na autorizadora',
    '114': 'Transação Bloqueada.',
    '116': 'Erro na consulta de transação. Por favor tente novamente mais tarde.',
    '131': 'Falha de comunicação com o SiTef',
    '134': 'Cartão Inválido, verifique o numero do cartão e a data de validade',
    '142': 'Erro ao consultar cartão: resposta inesperada da autorizadora',
    '143': 'O número de cartão enviado não corresponde à forma de pagamento escolhida.',
    '146': 'Erro na autenticação',
    '147': 'Autenticação Negada',
    '148': 'Autenticação não permitida para esta autorizadora',
    '255': 'Transação negada',
    '256': 'Aguardando resposta do cancelamento',
    '259': 'Transação negada',
    '302': 'Falha de comunicação',
    '400': 'Transação abortada',
    '920': 'Transação negada pela Cielo e-Commerce.',
    '930': 'Erro na comunicação com a Visa Checkout.',
};
